import React from "react";
import SaleHistoryComponent from "./SaleHistoryComponent";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
import { getSaleHistory } from "../../../api/salesApi";
import Subnav from "../SubNav";
import { useNavigate } from "react-router-dom";

const SaleHistory = () => {
  const navigate = useNavigate();
  async function exampleFetchSales(q) {
    const params = {
      page: q.page,
      pageSize: q.pageSize,
    };

    if (q.q) params.q = q.q;
    if (q.dateFrom) params.dateFrom = q.dateFrom;
    if (q.dateTo) params.dateTo = q.dateTo;
    if (q.status) params.status = q.status;
    if (q.sort && q.sort.field) {
      params.sortField = q.sort.field;
      params.sortDir = q.sort.dir;
    }

    const res = await getSaleHistory(params);
    // if (!res.ok) throw new Error("Failed to fetch sales");
    // return res.json();
    return res;
  }

  return (
    <div>
      <Navbar />
      <Subnav />
      <SaleHistoryComponent
        fetchSales={exampleFetchSales}
        onRowClick={(e) => navigate(`/sale/${e?.id}`)}
      />
      <Footer />
    </div>
  );
};

export default SaleHistory;
